const orgKey = 'orgTree'
export const setOrgTree = (org: string) => sessionStorage.setItem(orgKey, JSON.stringify(org))
export const getOrgTree = ():string => sessionStorage.getItem(orgKey) || '{}'

// User
const userKey = 'USER_INFO'
export const setUserInfo = (userInfo) => sessionStorage.setItem(userKey, JSON.stringify(userInfo))
export const getUserInfo = ():string => sessionStorage.getItem(userKey) || '{}'
// export const removeUserInfo = () => sessionStorage.removeItem(userKey)
